import { render, staticRenderFns } from "./headinfo.vue?vue&type=template&id=48961bc9&scoped=true"
import script from "./headinfo.vue?vue&type=script&lang=js"
export * from "./headinfo.vue?vue&type=script&lang=js"
import style0 from "./headinfo.vue?vue&type=style&index=0&id=48961bc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48961bc9",
  null
  
)

export default component.exports